import { JsonSerializable } from "@/Common/Models/JsonSerializable";
import { CareProviderRole } from "../Part1/CareProviderRole";

class BritishColumbiaObstetricalFileSignOff extends JsonSerializable {
    private id: number;

    public CareProviderName: string = "";
    public CareProviderRole: CareProviderRole = null;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileSignOff>) {
        super({ excludedFields: ["id"] });
        Object.assign(this, fields);

        this.id = sessionStore.newId();
    }

    public getId(): number {
        return this.id;
    }
}

export { BritishColumbiaObstetricalFileSignOff };
